import { Spinner } from "@repo/ui4/components/Spinner";
import { withWorkspacePrefix } from "@repo/workspace-route";
import { useRouter } from "next/router";
import { useEffect } from "react";
import { useAuthorizedUser } from "src/features/auth/useAuthorizedUser";
import { NotFoundScreen } from "../NotFoundScreen";

type BrowserLocation = {
  pathname: string;
  search: string;
  hash: string;
};

type Props = {
  location?: BrowserLocation;
};

export const getLegacyRedirectPath = ({
  workspaceId,
  pathname,
  search,
  hash,
}: BrowserLocation & { workspaceId: string }): string | null => {
  if (/^\/w(?:\/|$)/.test(pathname)) return null;

  const destinationPath = pathname === "/" ? "/home" : pathname;
  return withWorkspacePrefix(workspaceId, `${destinationPath}${search}${hash}`);
};

export const LegacyPathRedirect = ({ location }: Props) => {
  const router = useRouter();
  const { currentWorkspace } = useAuthorizedUser();
  const browserLocation =
    location ?? (typeof window === "undefined" ? null : window.location);
  const redirectPath =
    browserLocation == null
      ? undefined
      : getLegacyRedirectPath({
          workspaceId: currentWorkspace.id,
          pathname: browserLocation.pathname,
          search: browserLocation.search,
          hash: browserLocation.hash,
        });

  useEffect(() => {
    if (!router.isReady || redirectPath == null) return;
    router.replace(redirectPath);
  }, [redirectPath, router]);

  if (redirectPath === null) return <NotFoundScreen />;
  return (
    <div className="flex min-h-dvh items-center justify-center">
      <Spinner size="lg" aria-label="読み込み中" />
    </div>
  );
};
